import { SheetTitleSection } from '@optools/app/components/sheet/sheet-title-section';
import { Button } from '@optools/components/ui/button';
import { Card, CardContent } from '@optools/components/ui/card';
import { cn } from '@optools/components/ui/utils';
import { ActionType } from '@optools/services/operator-gateway/types/generated/graphql';
import { formatEnumValue } from '@optools/utils/format';
import { X } from 'lucide-react';
import { ReactNode } from 'react';

export interface ActionTypeCardProps {
  actionType: ActionType;
  children?: ReactNode;
  disabled?: boolean;
  onRemoveClicked: (actionType: ActionType) => void;
}

export function ActionTypeCard({
  actionType,
  children,
  disabled,
  onRemoveClicked,
}: ActionTypeCardProps) {
  return (
    <Card className="p-2" data-testid={actionType}>
      <CardContent className="flex h-full w-full flex-col items-center gap-4 p-2">
        <div className="flex w-full justify-between">
          <SheetTitleSection id={actionType} title="Action Type">
            {formatEnumValue(actionType)}
          </SheetTitleSection>
          <Button
            aria-label={`Remove ${actionType}`}
            className={cn({ invisible: disabled })}
            disabled={disabled}
            role="button"
            size="icon-xs"
            variant="outline"
            onClick={() => onRemoveClicked(actionType)}>
            <X />
          </Button>
        </div>
        {children}
      </CardContent>
    </Card>
  );
}
